'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ActivityDeclined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _string = require('utils/string');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Callout(_ref) {
  var hasEntry = _ref.hasEntry,
      entry = _ref.entry,
      polyglot = _ref.polyglot;

  return _react2.default.createElement(
    'span',
    null,
    hasEntry && _react2.default.createElement(
      'div',
      { className: 'callout' },
      _react2.default.createElement(
        'h5',
        { className: 'meta' },
        polyglot.t('notification.activity.declined.entry.item.message', { name: entry.item.name })
      ),
      _react2.default.createElement(
        'p',
        null,
        entry.item.message
      )
    )
  );
}

function _hasEntry(entry) {
  return entry && entry.item;
}

function ActivityDeclined(_ref2) {
  var source = _ref2.source,
      destination = _ref2.destination,
      entry = _ref2.entry,
      created_at = _ref2.created_at,
      btnDestroy = _ref2.btnDestroy,
      polyglot = _ref2.polyglot;

  var createdAt = (0, _moment2.default)(created_at.date).fromNow(); // eslint-disable-line camelcase

  return _react2.default.createElement(
    'div',
    { className: 'notification-rejected' },
    btnDestroy,
    _react2.default.createElement('i', { className: 'avatar-icon icon-primitive-dot' }),
    '\xA0',
    _react2.default.createElement('span', { dangerouslySetInnerHTML: {
        __html: polyglot.t('notification.activity.declined.message', {
          sourceName: (0, _string.trunc)(source.item.title ? source.item.title : '', 50),
          destinationName: destination.item.name
        })
      }
    }),
    '\xA0',
    _react2.default.createElement(
      'small',
      null,
      createdAt
    ),
    _react2.default.createElement(Callout, { entry: entry, hasEntry: _hasEntry(entry), polyglot: polyglot })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification/Activity/ActivityDeclined.js
// module id = 2232
// module chunks = 0